import React, { useMemo } from 'react';
import { Card, Col, Empty, Row, Table, Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import useGroup from '../../../../zustand/useGroup';
import useAppliedReportFilter from '../../../../hooks/useAppliedReportFilter';
import useReportLog from '../../../../hooks/useReportLog';
import {
  EPanelDoorName,
  EPanelDoorState,
} from '../../types/report-log.type';

const TabPanelDoor = () => {
  const { logs } = useReportLog();
  const { asset } = useAppliedReportFilter();
  const rows = useMemo(
    () =>
      Object.values(logs.panel_door || {}).sort(
        (a, b) => a.timestamp - b.timestamp,
      ),
    [logs.panel_door],
  );

  const openCount = rows.filter(
    (row) => row.state === EPanelDoorState.open,
  ).length;
  const closeCount = rows.filter(
    (row) => row.state === EPanelDoorState.closed,
  ).length;
  const latest = rows[rows.length - 1];

  const panelLabel = (value: EPanelDoorName) =>
    value === EPanelDoorName.engine ? 'Panel Engine' : 'Panel Anjungan';

  if (!rows.length) return <Empty description='No Door Panel data' />;

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card title='Total Changes'>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {rows.length} <Typography.Text type='secondary'>Event</Typography.Text>
            </Typography.Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card title='Open Count'>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {openCount} <Typography.Text type='secondary'>Event</Typography.Text>
            </Typography.Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card title='Close Count'>
            <Typography.Title level={3} style={{ margin: 0 }}>
              {closeCount} <Typography.Text type='secondary'>Event</Typography.Text>
            </Typography.Title>
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card title='Latest Panel Activity'>
            <Typography.Title level={4} style={{ margin: 0 }}>
              {latest ? dayjs(latest.dateTime).format('YYYY-MM-DD HH:mm:ss') : '-'}
            </Typography.Title>
          </Card>
        </Col>
      </Row>

      <Card
        title='Panel Open/Close Lid'
        style={{ marginTop: 16 }}
        extra={asset.name ? `Asset: ${asset.name}` : undefined}
      >
        <Table
          rowKey='id'
          dataSource={[...rows].reverse()}
          pagination={{ pageSize: 20 }}
          columns={[
            {
              title: 'Date & Time',
              dataIndex: 'dateTime',
              render: (value: string) =>
                dayjs(value).format('YYYY-MM-DD HH:mm:ss'),
            },
            {
              title: 'Change Status',
              dataIndex: 'state',
              align: 'center',
              render: (value: EPanelDoorState) => (
                <Tag color={value === EPanelDoorState.open ? 'green' : 'red'}>
                  {value === EPanelDoorState.open ? 'OPEN' : 'CLOSE'}
                </Tag>
              ),
            },
            {
              title: 'Panel Type',
              dataIndex: 'doorName',
              align: 'center',
              render: (value: EPanelDoorName) => (
                <Tag color={value === EPanelDoorName.engine ? 'purple' : 'black'}>
                  {panelLabel(value)}
                </Tag>
              ),
            },
          ]}
        />
      </Card>
    </div>
  );
};

export default TabPanelDoor;
